import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import Success from "@/pages/Success";
import Admin from "@/pages/Admin";
import AffiliatePortal from "@/pages/AffiliatePortal";
import Reseller from "@/pages/Reseller";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App bg-grain">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/success" element={<Success />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/affiliate" element={<AffiliatePortal />} />
          <Route path="/reseller" element={<Reseller />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="top-right" />
    </div>
  );
}

export default App;
